module.exports = __webpack_public_path__ + "media/images/games/fifa-21/square-0e6dabbb1186a54e73c97b002ec947fe.jpg";